/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@material-ui/core';
import DisplayResources from '../crud/DisplayResources';
import { resourceFields } from '../../data/Constants';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import { getProductNameWithCategory, getItemNameWithCategoryAndProduct, convertIdsToSeparatedNames } from '../../utils/Functions';
import LoadingBar from '../share/LoadingBar';
import { getUsers } from '../../domains/Restrictions';

const cloneDeep = require('lodash/cloneDeep');

const styles = commonResourceStyle();

class Restrictions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryIdsToNames: null,
      productIdsToNames: null,
      itemIdsToNames: null,
      userIdsToNames: null,
    };
  }

  componentDidMount() {
    const {
      coupons, actions, loading, apiToken, match,
    } = this.props;
    const { resource, subResource, resourceId } = match.params;

    if (loading === false) {
      actions.getAllResources(apiToken, 'categories')
        .then((res) => {
          const categoryIdsToNames = {};
          if (res.error || !res.response) {
            this.setState({ categoryIdsToNames });
            return;
          }
          if (Array.isArray(res.response)) {
            res.response.forEach((category) => {
              if (!category || !category.id || !category.name) return;
              categoryIdsToNames[`${category.id}`] = category.name;
            });
            this.setState({ categoryIdsToNames });
          }
        });
      actions.getAllResources(apiToken, 'products')
        .then((res) => {
          const productIdsToNames = {};
          const itemIdsToNames = {};
          if (res.error || !res.response) {
            this.setState({ productIdsToNames, itemIdsToNames });
            return;
          }
          if (Array.isArray(res.response)) {
            const buildUpProductsAndItemNames = (product) => {
              const invalidProduct = !product || !product.name
                || !product.category || !product.category.name;
              if (!invalidProduct && product.id) {
                productIdsToNames[`${product.id}`] = getProductNameWithCategory(product);
              }
              const { items } = product;
              if (!items || !Array.isArray(items)
                || (Array.isArray(items) && items.length === 0)) return;
              items.forEach((item) => {
                if (!item || !item.id || !item.name || invalidProduct) return;
                itemIdsToNames[`${item.id}`] = getItemNameWithCategoryAndProduct(item, product);
              });
            };
            res.response.forEach(buildUpProductsAndItemNames);
            this.setState({ productIdsToNames, itemIdsToNames });
          }
        });
      actions.getAllResources(apiToken, 'locations')
        .then((res) => {
          const locationIdsToNames = {};
          if (res.error || !res.response) {
            this.setState({ locationIdsToNames });
            return;
          }
          if (Array.isArray(res.response)) {
            res.response.forEach((location) => {
              if (!location || !location.id || !location.name) return;
              locationIdsToNames[`${location.id}`] = location.name;
            });
            this.setState({ locationIdsToNames });
          }
        });
      if (!coupons) {
        new Promise((resolve, reject) => {
          actions.getAllResources(apiToken, resource).then(
            actions.getAllResources(apiToken, resource, resourceId, subResource),
          );
          resolve();
        }).catch();
      } else {
        const restrictions = this.retrieveItems();
        if (!restrictions) actions.getAllResources(apiToken, resource, resourceId, subResource);
      }
    }
  }

  componentDidUpdate() {
    const { actions, apiToken, coupons } = this.props;
    const { userIdsToNames } = this.state;
    const newUserIdsToNames = {};
    const restrictions = coupons && this.retrieveItems();
    if (restrictions && restrictions.length > 0 && !userIdsToNames) {
      const userRestrictions = restrictions.filter(restriction => restriction.type === 'USERS');
      const userIds = userRestrictions.map(restriction => restriction.value).join();
      let paginationStart = 0;
      let paginationEnd = userRestrictions.length;
      do {
        // eslint-disable-next-line no-unused-expressions
        userIds && actions.getSearchedUsers(apiToken, `users?start=${paginationStart}&count=${paginationEnd}&filter=id:${userIds}`)
          .then((res) => {
            const users = (getUsers(res));
            if (Array.isArray(users)) {
              users.forEach((user) => {
                if (!user || !user.value || !user.label) return;
                newUserIdsToNames[`${user.value}`] = user.label;
              });
              this.setState({ userIdsToNames: newUserIdsToNames });
            }
            return newUserIdsToNames;
          });
        paginationStart = paginationEnd;
        paginationEnd += userRestrictions.length;
      }
      // eslint-disable-next-line react/destructuring-assignment
      while (this.state.userIdsToNames && this.state.userIdsToNames.length !== userIds.split(',').length);
    }
  }

  retrieveItems = () => {
    const { coupons, match } = this.props;
    const { resourceId } = match.params;
    const currentCoupon = coupons.find(coupon => coupon.id == resourceId);
    return currentCoupon ? currentCoupon.restrictions : [];
  };

  convertIdsToNames = (restrictions) => {
    if (!restrictions) return [];
    const {
      categoryIdsToNames,
      productIdsToNames,
      itemIdsToNames,
      userIdsToNames,
    } = this.state;
    const prettierRestrictions = restrictions.map((restriction) => {
      const restrictionClone = cloneDeep(restriction);
      const { type, value } = restrictionClone;
      if (!['CATEGORY', 'EXCLUDE_CATEGORY', 'PRODUCT', 'EXCLUDE_PRODUCT', 'PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM', 'USERS'].includes(type)) return restrictionClone;
      let idsToNamesMap;
      if (['CATEGORY', 'EXCLUDE_CATEGORY'].includes(type) && typeof value === 'string') {
        idsToNamesMap = categoryIdsToNames;
      }
      if (['PRODUCT', 'EXCLUDE_PRODUCT'].includes(type) && typeof value === 'string') {
        idsToNamesMap = productIdsToNames;
      }
      if (['PRODUCT_ITEM', 'EXCLUDE_PRODUCT_ITEM'].includes(type) && typeof value === 'string') {
        idsToNamesMap = itemIdsToNames;
      }
      if (['USERS'].includes(type) && typeof value === 'string') {
        idsToNamesMap = userIdsToNames;
      }
      return convertIdsToSeparatedNames(restrictionClone, 'value', idsToNamesMap, ', ');
    });
    return prettierRestrictions;
  }

  render() {
    const {
      coupons, actions, loading, apiToken, match,
    } = this.props;
    const {
      resource, resourceId,
    } = match.params;
    const currentCoupon = (coupons && coupons.length > 0)
      && (coupons.filter(coupon => coupon.id.toString() === resourceId.toString()));
    const restrictions = (currentCoupon && currentCoupon[0]) ? currentCoupon[0].restrictions : [];
    const prettierRestrictions = this.convertIdsToNames(restrictions);
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Restrictions</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} resourceId={resourceId} />
              </div>
            </div>
            <Paper style={styles.paper}>
              <DisplayResources
                data={prettierRestrictions}
                actions={actions}
                fieldNames={resourceFields.restrictions}
                resourceName="restrictions"
                apiToken={apiToken}
              />
            </Paper>
          </div>
        )
    );
  }
}

Restrictions.propTypes = {
  loading: PropTypes.bool.isRequired,
  coupons: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

Restrictions.defaultProps = {
  coupons: null,
};

export default withRouter(Restrictions);
